<template>
    <el-dialog title="添加心仪专业" :visible="true" :modal="true" :show-close="false" class="dialog-box dialog-identify">
        <img src="../assets/images/close.png" alt="关闭" @click="closeHandler">
        <div class="search-img header-search">
            <div v-if="!level" class="level-view1">
                <span v-for="(item, key) in major_level_list1" :key="key" :class="major_active_level1 == key?'active-level1':''" @click="changeMajorLevel1(key)">{{ item }}</span>
            </div>
            <el-input placeholder="搜索专业名称" v-model="search.special_name" clearable @keyup.enter.native="getSpecialList">
                <template slot="append">
                    <img src="@/assets/images/sousuo.png" alt="搜索" @click="getSpecialList">
                </template>
            </el-input>
        </div>
        <div class="level-view2">
            <div v-for="(item, key) in major_level_list2.slice(0, level_length)" :key="key" :class="major_active_level2 == key?'active-level2':''" @click="changeMajorLevel2(key)">
                {{ item.level2_name }}
            </div>
            <el-popover
                placement="top"
                popper-class="popper-view"
                trigger="click"
                :visible-arrow="false"
                @hide="show_more=false"
            >
            <div v-for="(item, key) in major_level_list2.slice(level_length, major_level_list2.length-1)" :key="level_length+key" :class="['level-item',major_active_level2 == (level_length+key)?'more-view':'']" @click="changeMajorLevel2(level_length+key)">
                {{ item.level2_name }}
            </div>
                <div class="more-view" slot="reference" @click="show_more=!show_more">更多<i v-if="!show_more" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i></div>
            </el-popover>
        </div>
        <el-row>
            <el-col :span="6">
                <el-scrollbar wrap-class="vertical_scrollbar">
                    <a  @click="changeMajorLevel3(key)" v-for="(item, key) in major_level_list3" :key="key" :class="['item-view', major_active_level3 === key ? 'acitve-item' : '']">
                        {{ item.level3_name }}
                    </a>
                </el-scrollbar>
            </el-col>
            <el-col :span="18">
                <el-scrollbar v-if="major_total > 0" wrap-class="vertical_scrollbar">
                    <div class="provice-view">{{ major_level_list4[0].level3_name }}</div>
                    <div v-for="(item, key) in major_level_list4" :key="key" class="item-view" @click="selectMajor(item, key)">
                        {{ item.special_name }}
                        <img v-if="!item.checked" src="@/assets/images/select_icon1.png">
                        <img v-else src="@/assets/images/select_icon2.png">
                    </div>
                </el-scrollbar>
                <div v-if="major_total === 0" class="no-data-box">
                    <img src="@/assets/images/null.png" alt="没有数据">
                    <p>暂无专业信息</p>
                </div>
            </el-col>
        </el-row>
        <div class="flex">
            <el-popover
                placement="top"
                popper-class="popper-view"
                trigger="click"
                :visible-arrow="false"
                @hide="show_data=false"
            >
                <el-table :data="select_major">
                    <el-table-column prop="special_name" min-width="200"></el-table-column>
                    <el-table-column width="100" align="right">
                        <template slot-scope="scope">
                            <div class="remove-btn" @click="removeMajor(scope.row, scope.$index)">移除</div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="add-count" slot="reference" @click="show_data=!show_data">已添加：<span>{{ select_major.length }}</span>/5<i v-if="!show_data" class="el-icon-arrow-down"></i><i v-else class="el-icon-arrow-up"></i></div>
            </el-popover>
            <div>
                <el-button @click="closeHandler">取消</el-button>
                <el-button class="save-btn" @click="addMajor">保存</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { getAllLevel3, getAllLevel2, getSpecialList } from '@/api/query_subject'
export default {
    name: 'IntentionMajor',
    props: ['majorList', 'level'],
    data() {
        return {
            search: {
                special_name: '',
            },
            select_major: [],
            show_data: false,
            show_more: false,
            major_level_list1: { 1: '本科', 2: '专科' },
            major_active_level1: 1,
            major_active_level2: 0,
            major_active_level3: 0,
            major_level_list2: [],
            major_level_list3: [],
            major_level_list4: [],
            major_total: -1,
            level_length: 8
        }
    },
    mounted() {
        this.select_major = [...this.majorList]
        if(this.level) {
            this.major_active_level1 = this.level
        }
        this.getAllLevel2()
    },
    methods: {
        closeHandler() {
            this.$store.commit('user/SHOWINTENTIONMAJOR', false)
        },
        searchData() {

        },
        // 一级专业分类
        getAllLevel2() {
            const level1 = this.major_active_level1
            getAllLevel2(level1).then(res => {
                this.major_level_list2 = res.data
                this.getAllLevel3()
            })
        },
        // 二级专业分类
        getAllLevel3() {
            const params = {
                level1: this.major_active_level1,
                level2: this.major_level_list2[this.major_active_level2].level2
            }
            getAllLevel3(params).then(res => {
                this.major_level_list3 = res.data
                this.getSpecialList()
            })
        },
        // 三级专业分类
        getSpecialList() {
            getSpecialList(this.search.special_name, this.major_active_level1, this.major_level_list2[this.major_active_level2].level2, this.major_level_list3[this.major_active_level3].level3).then(res => {
                const data = res.data.data
                data.data.map(item => item.checked = false)
                this.major_total = data.total
                this.select_major.map(item => {
                    const index_tmp = data.data.findIndex(val => { return val.special_id === item.special_id })
                    if(index_tmp > -1) {
                        data.data[index_tmp].checked = true
                    }
                })
                this.major_level_list4 = data.data
            })
        },
        // 改变一级专业
        changeMajorLevel1(index) {
            if(Number(index) === 1) {
                this.level_length = 8
            } else {
                this.level_length = 4
            }
            this.major_active_level1 = index
            this.major_active_level2 = 0
            this.major_active_level3 = 0
            this.major_level_list2 = []
            this.major_level_list3 = []
            this.major_level_list4 = []
            this.major_total = -1
            this.getAllLevel2()
        },
        // 改变二级专业
        changeMajorLevel2(index) {
            this.major_active_level2 = index
            this.major_active_level3 = 0
            this.major_level_list3 = []
            this.major_level_list4 = []
            this.major_total = -1
            this.getAllLevel3()
        },
        // 改变三级专业
        changeMajorLevel3(index) {
            this.major_active_level3 = index
            this.major_level_list4 = []
            this.major_total = -1
            this.getSpecialList()
        },
        // 选择专业
        selectMajor(data, key) {
            const index_tmp = this.select_major.findIndex(val => { return val.special_id === data.special_id })
            if(index_tmp === -1) {
                if(this.select_major.length > 4) {
                    return
                }
                data.checked = true
                this.select_major.push(data)
            } else {
                data.checked = false
                this.select_major.splice(index_tmp, 1)
            }
        },
        // 专业提交
        addMajor() {
            this.$emit('update', this.select_major)
            this.closeHandler()
        },
        // 移除专业
        removeMajor(data, index) {
            const index_tmp = this.major_level_list4.findIndex(val => { return val.special_id === data.special_id })
            if(index_tmp > -1) {
                this.major_level_list4[index_tmp].checked = false
            }
            this.select_major.splice(index, 1)
        }
    }
}
</script>

<style lang='scss' scoped>
@import "@/assets/css/variables.scss";
.dialog-box {
    ::v-deep .el-dialog {
        height: 600px;
        width: 720px;
        .vertical_scrollbar {
            overflow-x: hidden;
            height: 300px;
            padding-bottom: 20px;
        }
        .el-button {
            width: 100px!important;
            height: 44px!important;
            background: #ffffff!important;
            border: 1px solid #c4c7cc!important;
            border-radius: 8px;
            color: #5e6166!important;
            font-size: 16px;
        }
        .save-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c)!important;
            border: none!important;
            color: #ffffff!important;
        }
    }
    img {
        width: 24px;
        height: 24px;
        position: absolute;
        right: 40px;
        top: 40px;
        z-index: 999;
    }
    .el-col-6 {
        padding-right: 18px;
        border-right: 1px solid #e1e4eb;
    }
    .item-view {
        padding: 12px 0;
        border-bottom: 1px solid #e1e4eb;
        font-size: 14px;
        color: #5e6166;
        line-height: 20px;
        cursor: default;
        display: block;
        text-decoration: none;
        position: relative;
    }
    .acitve-item {
        color: #ff6524;
    }
    .provice-view {
        color: #999390;
        margin-top: 12px;
    }
    .el-col-18 {
        padding-left: 16px;
        .item-view {
            color: #2c2e33;
            padding: 12px 0;
            img {
                position: absolute;
                right: 0;
                top: 15px;
                width: 20px;
                height: 20px;
            }
        }
    }
    .flex {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .add-count {
            font-size: 14px;
            span {
                color: #ff6524;
            }
        }
    }
}
.remove-btn {
    color: #ff6524;
    cursor: pointer;
}
.el-icon-arrow-down {
    color: #c4c7cc;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
    top: 2px;
}
.el-icon-arrow-up {
    color: #ff6524;
    font-size: 14px;
    margin-left: 6px;
    position: relative;
}
::v-deep .header-search {
    position: relative;
    z-index: 1000;
    display: flex;
    .el-input__inner {
        padding: 0 16px;
    }
    .el-input-group__append {
        img {
            position: absolute;
            top: 10px;
            right: 16px;
        }
    }
}
.level-view1 {
    flex: 0 0 114px;
    height: 44px;
    line-height: 32px;
    background: #ffffff;
    border: 1px solid #e1e4eb;
    border-radius: 8px;
    margin-right: 16px;
    color: #5e6166;
    font-size: 16px;
    padding: 4px 5px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    .active-level1 {
        background: #ff6524;
        border-radius: 4px;
        color: #ffffff;
    }
    span {
        margin: 0 4px;
        width: 52px;
        height: 34px;
        text-align: center;
    }
}
.level-view2 {
    display: flex;
    flex-wrap: wrap;
    margin: 16px 0;
    div {
        font-size: 14px;
        color: #5e6166;
        padding: 4px;
        cursor: pointer;
    }
    div:not(:last-child) {
        margin-right: 24px;
    }
    .active-level2 {
        background: #ff6524;
        border-radius: 4px;
        color: #ffffff;
    }
    
}
.more-view {
    color: #ff6524!important;
}
.level-item {
    text-align: center;
}
.level-item:not(:last-child) {
    margin-bottom: 12px;
}
.no-data-box {
    text-align: center;
    position: absolute;
    top: 50%;
    left: 67%;
    transform: translate(-50%, -50%);
    img {
        width: 110px!important;
        height: 110px!important;
        position: relative;
        top: 0;
        right: auto;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #abaeb3;
    }
}
</style>